/**
 * @author Fernando Tapia <ftapia@pensare.mx>
 * @version 2.0.0
 * @file Manages the data constants by the project
 */
export const URL_SERVER = "https://back.estrategas.mx:8443/";
// export const URL_SERVER = "http://localhost:8082/";
//Access control
export const LOG_IN = "login";
export const GET_INFO_ROL = "user/rol";

//Url services
export const HEADER_INFO = "ceo/header-month/";

export const ANNUAL_INCOME = "ceo/annual-income/";
export const INCOME_DISCOUNTS = "ceo/income-discounts/";
export const MONTHLY_RECOVERY = "ceo/monthly-recovery/";
export const ANNUAL_ACCOUNTS = "ceo/monthly-recovery/acummulated-accounts";
export const ACCOUNTS_STATUS = "ceo/monthly-recovery/status-accounts";
export const DEBT_RECOVERY = 'ceo/monthly-recovery/status-accounts-table-one';
export const DEBT_RECOVERY_PERCENT = 'ceo/monthly-recovery/status-accounts-table-two';
export const DEBT_RECOVERY_TOTAL = '/ceo/monthly-recovery/status-accounts-table-total';
export const MONTHLY_RECOVERY_ACCOUNTS = "ceo/monthly-recovery-accounts/";
export const RESTRICTED_ACCOUNTS = "ceo/restricted-accounts/";
export const MONTHLY_PORTFOLIO = "ceo/amount-portfolio/";
export const LOST_UTILITY = "ceo/cost-expense/";
export const MONTHLY_RECOVERY_ACUMMULATED = 'ceo/monthly-recovery/acummulated/';
export const DAILY_RECOVERY_ACUMMULATED = 'ceo/monthly-recovery/acummulated-daily/';
export const ACCOUNTS_SURFACE_DIFFERENCE = 'ceo/sdo/differences-square-meters/';
export const USE_DIFFERENCE = 'ceo/sdo/differences-use/';
export const INCREASED_VALUE_ACCOUNTS = 'ceo/sdo/increased-value-accounts/';

export const OPERATION_LABEL = "operation/";
export const VISIT_SCHEDULE = "/visit/";
export const AGENT_PERFORMANCE = "/incoming/";
export const TELEPHONE_CAPTURE_QUALITY = "/telephone_status";
export const PERFORMANCE_PROCEDURE = "/performance_procedure";
export const WEEK_PLANNING = "/weeks-planning";

export const PERFORMANCE_ANALYSIS = "operation/performance-analysis/";
export const PORTFOLIO_ACCOUNTS_CLASSIFICATION = "/classification-deleted-accounts";
export const GLOBAL_PORTFOLIO_REDUCE = "/global-decrease-portfolio";

export const PORTFOLIO_STATUS_OPERATION = "/portfolio-status-in-operation";

export const OPTIMIZATION_MONITORING = "operation/optimization-monitoring/";
export const POTENTIAL_BILLING_INCREASE = "/increase-in-potential";
export const ACCUMULATED_OPTIMIZATION_CATEGORIES = "/accumulated-optimization-categories";
export const ACCOUNTS_IDENTIFIED_FOR_OPTIMIZATION = "/accounts-identified-optimization";

export const REO = "reo/";
export const PLAZA = "/plaza/";
export const CONTACT_CENTER = '/contact-center/';


// Quality
export const INDICATORS  = "quality/indicators/";
export const EDIT_INDICATORS = 'quality/indicators-save';
export const VIEW_ACTIONS = 'quality/indicators-info/';
export const UPLOAD_ACTIONS = 'quality/indicators-save-info';
export const COMPLIANCE_AUDITS = 'compliance-audits/';
export const EDIT_COMPLIANCE_AUDITS = 'compliance-audits/save';
export const AUDIT_REPORT = 'quality/report-audits/';
export const SAVE_AUDIT_REPORT = 'quality/report-audits/save';
export const SATISFACTION_INDEX = 'quality/satisfaction-index/';
export const EDIT_SATISFACTION_INDEX = 'quality/satisfaction-index/save';
export const PARTICULAR_RESULTS = 'quality/particular-result/';
export const SAVE_PARTICULAR_RESULTS = 'quality/particular-result/save';
export const MONTHLY_CLAIMS = 'quality/claims/monthly/';
export const CLAIMS = 'quality/claims/';
export const EDIT_CLAIMS = 'quality/claims/save/';

//Human Resources
export const TEMPLATE_COVERAGE = 'rrhh/coverage-of-workforce/';
export const EDIT_TEMPLATE_COVERAGE = 'rrhh-admin/coverage-of-workforce';
export const TRAININGS = 'rrhh/formation/';
export const EDIT_TRAININGS = 'rrhh-admin/formation';
export const PAYROLL_COST = 'rrhh/payroll/';
export const EDIT_PAYROLL_COST = 'rrhh-admin/payroll-cost';
export const CATALOGUE_PAYROLL_COST = 'rrhh-admin/catalog/payroll-cost';
export const ASSOCIATES_SATISFACTION = 'rrhh/satisfaction-associates/';
export const EDIT_ASSOCIATES_SATISFACTION = 'rrhh-admin/satisfaction-associates';
export const CATALOG_SATISFACTION = 'rrhh-admin/catalog/satisfaction';
export const CATALOG_BUSINESS_UNITS =  '/catalog/business-units';

//New Business
export const NEW_BUSINESS = 'commercial-area/view/';
export const UPDATE_NEW_BUSINESS = 'commercial-area/update';
export const SAVE_NEW_BUSINESS = 'commercial-area/save';
export const CATALOG_NEW_BUSINESS_ESTATE = '/catalog/commercial-area/estate';
export const CATALOG_NEw_BUSINESS_MUN = 'catalog/commercial-area/municipality/';
export const CATALOG_NEW_BUSINESS_OP_TYPE = 'catalog/commercial-area/operation-type';
export const CATALOG_NEW_BUSINESS_PHASE =  'catalog/commercial-area/phase';
export const SAVE_NEW_BUSINESS_FILE = 'commercial-area/file/';
export const VIEW_NEW_BUSINESS_FILE = 'commercial-area/file/';
export const VIEW_NEW_BUSINESS_FILE_SUMMARY = 'commercial-area/file/summary/';
export const NEW_BUSINESS_TARGET_CONTRACTS = 'commercial-area/target-contract/';
export const NEW_BUSINESS_CONTRACTS = 'commercial-area/contract/';
export const DELETE_NEW_BUSINESS = 'commercial-area/';
export const NEW_BUSINESS_NOTE = 'commercial-area/note';
export const NEW_BUSINESS_VISITS = 'commercial-area/appointment';


//News
export const DELETE_NEW = 'news/delet/';
export const SAVE_NEW = 'news/save';
export const UPDATE_IMAGE_NEW = 'news/update/image';
export const UPDATE_NEW = 'news/update/info';
export const NEWS = 'news/view/';

// Directory
export const DIRECTORY = 'directory/get?page=';
export const DIRECTORY_SEARCH = '/directory/find/';


export const BUSINESS_UNIT = 'user/business-units';

//Data information
export const WHITOUT_INFORMATION = "Sin información";

//Styles
export const GRAPH_MARGIN = {top: 0, right: 5, left: 50, bottom: 0};

//Enums
//Rol
export const ROL = {
  CLIENT: {value: 1, url: 'client'},
  OPERATION: {value: 5, url: 'operation'},
  DIRECTION: {value: 4, url: 'direction'},
  MANAGEMENT: {value: 6, url: 'management'},
  SUPERVISOR: {value: 9, url: 'supervisor'},
  QUALITY_MANAGER: {value: 11, url: 'direction'},
  HUMAN_RESOURCES_MANAGER: {value: 14, url: 'direction'}
};

//Rol url
export const ROL_URL = {
  CLIENT: '/profile-client/place/',
  MANAGEMENT: '/management-home/',
  CLIENT_GIS: '/profile-client/gis/',
  SUPERVISOR: '/supervisor-home/',
  QUALITY_MANAGER: '/direction/',
  HUMAN_RESOURCES_MANAGER: '/direction/'
};

//Methods HTTP
export const METHOD = {
  POST: 'POST',
  GET: 'GET'
};

//Graphic colors
export const COLORS = {
  GOAL: '#008B29',
  AMOUNT: '#00476E',
  BASE: '#AB181F',
  SUMMARY_GREEN: '#2ABB00',
  SUMMARY_GRAY: '#646464',
  BLACK: '#000',
  TITLE: '#4D4F5C'
};

export const MONTHS = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

export const voidData = [
  {month: 'ene', amount: 0},
  {month: 'feb', amount: 0},
  {month: 'mar', amount: 0},
  {month: 'abr', amount: 0},
  {month: 'may', amount: 0},
  {month: 'jun', amount: 0},
  {month: 'jul', amount: 0},
  {month: 'ago', amount: 0},
  {month: 'sep', amount: 0},
  {month: 'oct', amount: 0},
  {month: 'nov', amount: 0},
  {month: 'dic', amount: 0},
];

// Data maps
export const API_KEY = "AIzaSyCNTKnDtJVnRJYu5ylhU-BQE6h0YhYNMjE";
export const MAPS_URL_API = "https://maps.googleapis.com/maps/api/js?key=" + API_KEY + "&v=3.exp&libraries=geometry,drawing,places"

//Table maps colors
export const HEADER={
  COLOR:'#FFFFFF',
  BACKCOLOR:'#7FA1AE',
  FONTSIZE:'20px',
  WIDTH: 'auto',
  WIDTH2: '200px',
  HEIGHT: '50px'
};



// WEBPACK FOOTER //
// ./src/utils/constants.js